import { ofType } from 'redux-observable'
import {
    DATA_SHIP_CLASSIFICATION_LIST_GET,
} from '../actionType'
import { catchError, switchMap, map } from 'rxjs/operators'
import { of } from 'rxjs'
import shipService from '../../services/shipService'
import {
    datashipClassificationListGetFAction,
    datashipClassificationListGetRAction,
} from '../action/dataShipClassAction'


export const dataShipClassEpics = (action$: any) => {
    return action$.pipe(
        ofType(DATA_SHIP_CLASSIFICATION_LIST_GET),
        switchMap((action: any) => {
            return shipService.getDatalasticShip(action.payload).pipe(
                map((res: any) => {
                    console.log(action.payload,'action payload in ship company')
                    const { content, total_page, total_element } = res.data
                    console.log(content,'content shop epic')
                    // console.log(total_page)
                    // console.log(total_element)
                    return datashipClassificationListGetFAction({ content, total_page, total_element })
                }),
                catchError((err: any) => of(datashipClassificationListGetRAction(err)))
            )
        })
    )
}

